import { fromTemplate } from '../../utils/dom.js';
import './contact.css';

export class Contact {
  render() {
    const template = `
      <section class="sl-contact" id="contact" data-testid="contact">
        <div class="container sl-contact__inner">
          <h2 class="sl-contact__title">Let&rsquo;s build something</h2>
          <p class="sl-contact__lede">
            Have a project in mind, or just want to say hello? We&rsquo;d love
            to hear from you.
          </p>
          <a class="sl-btn sl-btn--primary"
             href="mailto:hello@strikinglabs.com"
             data-testid="contact-email">hello@strikinglabs.com</a>
        </div>
      </section>
    `;
    return fromTemplate(template);
  }
}
